module.exports = __webpack_public_path__ + "05_bob_brown.019c7be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/05_bob_brown.png
// module id = QcNR
// module chunks = 0